export const addLeanIXMapping = ({
  selectedLeanix,
  percentage,
  leanIXMapping,
  totalPercentage
}) => {
  let leanIXError = null;
  let percentageError = null;

  if (!selectedLeanix) {
    leanIXError = "Please select a LeanIX ID.";
  }

  if (!isValidPercentage(percentage) || percentage == "" || Number(percentage) === 0) {
    percentageError = "Please enter a valid percentage.";
  }

  if(Number(percentage)  + totalPercentage > 100){
    percentageError = "Total allocation cannot exceed 100.";
  }

  const alreadyExists = leanIXMapping.some(
    m => m.leanIX?.id === selectedLeanix?.id
  );
  if (alreadyExists) {
    leanIXError = "This LeanIX ID is already present.";
  }

  if (leanIXError || percentageError) {
    return {
      updatedMappings: leanIXMapping,
      leanIXError,
      percentageError
    };
  }

  const newMapping = {
    leanIX: {
      id: selectedLeanix.id,
      label: selectedLeanix.label,
      value: selectedLeanix.value
    },
    percentage: percentage === "" ? null : Number(percentage)
  };

  return {
    updatedMappings: [...leanIXMapping, newMapping],
    leanIXError: null,
    percentageError: null
  };
};

export const isValidPercentage = (val) => {
  if (val === "" || val == null) return true;
  if (typeof val === "number") val = val.toString();

  return (
    /^(\d{1,2}(\.\d?)?|\.\d?)$/.test(val) && Number(val) <= 100 ||
    /^100(\.0)?$/.test(val)
  );
};

export const handlePercentageChange = (val, setter, setError) => {
  // Always allow empty string so backspace works
  if (isValidPercentage(val)) {
    setter(val);
    if (setError) setError(""); // clear error if valid
  }
};

export const handlePercentageKeyDown = (e) => {
  if (["e", "E", "+", "-"].includes(e.key)) {
    e.preventDefault();
  }
};

export const handlePercentagePaste = (e) => {
  e.preventDefault(); // block paste
};